import { render, staticRenderFns } from "./policyList.vue?vue&type=template&id=4dee05be&scoped=true&"
import script from "./policyList.vue?vue&type=script&lang=js&"
export * from "./policyList.vue?vue&type=script&lang=js&"
import style0 from "./policyList.vue?vue&type=style&index=0&id=4dee05be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee05be",
  null
  
)

export default component.exports